export default __webpack_public_path__ + "a7f2500d3e235b159aa2c37bc7833a78.svg";